import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import avatar from 'flarum/common/helpers/avatar';
import icon from 'flarum/common/helpers/icon';
import IndexPage from 'flarum/forum/components/IndexPage';
import type Mithril from 'mithril';
import type ItemList from 'flarum/common/utils/ItemList';

function cratePostAreaView() {
  const canStartDiscussion = app.forum.attribute('canStartDiscussion') || !app.session.user;

  return (
    <div className="Brickrr-CreatePostArea" onclick={() => canStartDiscussion && IndexPage.prototype.newDiscussionAction().catch(() => {})}>
      <div className="Brickrr-CreatePostArea-icon">
        {app.session.user ? avatar(app.session.user, { className: 'Brickrr-CreatePostArea-avatar' }) : icon('fa-light fa-circle-user')}
      </div>
      <div className="Brickrr-CreatePostArea-text">
        {app.translator.trans(canStartDiscussion ? 'core.forum.index.start_discussion_button' : 'core.forum.index.cannot_start_discussion_button')}...
      </div>
    </div>
  );
}

function pushCreatePostArea() {
  extend(IndexPage.prototype, 'view', function (this: IndexPage, vdom: Mithril.Vnode) {
    // @ts-ignore
    let vnode = vdom.children[1]?.children[0]?.children[1];
    // @ts-ignore
    if (!vnode) vnode = vdom.children[1]?.children[1]?.children[1];

    if (vnode) vnode.children = [cratePostAreaView(), ...vnode.children];
  });
}

function removeStartDiscussionButton() {
  extend(IndexPage.prototype, 'sidebarItems', function (this: IndexPage, items: ItemList<Mithril.Children>) {
    if (items.has('newDiscussion')) items.remove('newDiscussion');
  });
}

export default function createPostArea() {
  pushCreatePostArea();
  removeStartDiscussionButton();
}
